(() => {
  const root = document.documentElement;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const coarsePointer = window.matchMedia('(pointer: coarse)');
  const recentKey = 'culm-recent-products';

  const routes = {
    men: '/collections/trybuy-shirt-men',
    new: '/collections/new-arrivals-shirts',
    best: '/collections/best-sellers',
    checked: '/collections/mens-checked-shirts',
    printed: '/collections/mens-printed-linen-shirts',
    solid: '/collections/solid-shirts-for-men',
    striped: '/collections/striped-shirts-for-men',
    white: '/collections/white-shirts-for-men',
    black: '/collections/black-shirts-for-men',
    blue: '/collections/blue-shirts-for-men',
    brown: '/collections/brown-shirts-for-men'
  };

  const readRecent = () => {
    try {
      const value = JSON.parse(localStorage.getItem(recentKey) || '[]');
      return Array.isArray(value) ? value.slice(0, 4) : [];
    } catch (_) { return []; }
  };

  const writeRecent = (items) => {
    try { localStorage.setItem(recentKey, JSON.stringify(items.slice(0, 4))); } catch (_) {}
  };

  const rememberCurrentProduct = () => {
    const node = document.querySelector('[data-culm-product-context]');
    if (!node) return;
    const item = {
      title: node.dataset.productTitle || '',
      path: window.location.pathname,
      type: node.dataset.productType || 'Shirt',
      price: node.dataset.productPrice || '',
      fibre: node.dataset.productFibre || ''
    };
    if (!item.title) return;
    const next = [item, ...readRecent().filter((entry) => entry.path !== item.path)];
    writeRecent(next);
  };

  const selectedOptions = () => [...document.querySelectorAll('[data-culm-option]')].map((select) => ({
    name: select.name || '', value: select.value || ''
  }));

  const pageContext = () => {
    const productNode = document.querySelector('[data-culm-product-context]');
    const collectionNode = document.querySelector('[data-culm-collection-context]');
    return {
      pageType: (document.body.className.match(/template-([^\s]+)/) || [])[1] || 'page',
      pathname: window.location.pathname,
      title: document.title,
      product: productNode?.dataset.productTitle || document.querySelector('.culm-shirt-product__title, .culm-product__title')?.textContent.trim() || '',
      productType: productNode?.dataset.productType || '',
      price: productNode?.dataset.productPrice || '',
      fibre: productNode?.dataset.productFibre || '',
      collection: collectionNode?.dataset.collectionTitle || document.querySelector('.culm-shirt-collection__title, .culm-collection__head h1')?.textContent.trim() || '',
      selectedOptions: selectedOptions(),
      recentProducts: readRecent()
    };
  };

  const setLowImpact = (enabled, persist = true) => {
    root.classList.toggle('culm-low-impact', enabled);
    document.querySelectorAll('[data-culm-impact-toggle]').forEach((button) => button.setAttribute('aria-pressed', enabled ? 'true' : 'false'));
    document.querySelectorAll('[data-culm-impact-label]').forEach((label) => { label.textContent = enabled ? 'Low impact on' : 'Low impact'; });
    document.querySelectorAll('[data-culm-impact-state]').forEach((node) => {
      node.textContent = enabled ? 'Low-impact display is active on this device.' : 'Standard visual mode is active. Rich media still loads on request.';
    });
    if (enabled) document.querySelectorAll('video').forEach((video) => { if (!video.paused) video.pause(); });
    if (persist) {
      try { localStorage.setItem('culm-low-impact', enabled ? '1' : '0'); } catch (_) {}
    }
  };

  const initImpactControls = () => {
    setLowImpact(root.classList.contains('culm-low-impact'), false);
    document.querySelectorAll('[data-culm-impact-toggle]').forEach((button) => {
      button.addEventListener('click', () => setLowImpact(!root.classList.contains('culm-low-impact'), true));
    });
  };

  const initImmersive = () => {
    if (reducedMotion.matches || coarsePointer.matches || root.classList.contains('culm-low-impact')) return;
    document.querySelectorAll('[data-culm-immersive-stage]').forEach((stage) => {
      const move = (event) => {
        const box = stage.getBoundingClientRect();
        const x = (event.clientX - box.left) / box.width - .5;
        const y = (event.clientY - box.top) / box.height - .5;
        stage.style.setProperty('--culm-ry', `${x * 9}deg`);
        stage.style.setProperty('--culm-rx', `${-y * 8}deg`);
        stage.style.setProperty('--culm-mx', `${x * 34}px`);
        stage.style.setProperty('--culm-my', `${y * 34}px`);
      };
      const reset = () => {
        stage.style.setProperty('--culm-ry', '0deg');
        stage.style.setProperty('--culm-rx', '0deg');
        stage.style.setProperty('--culm-mx', '0px');
        stage.style.setProperty('--culm-my', '0px');
      };
      stage.addEventListener('pointermove', move, { passive: true });
      stage.addEventListener('pointerleave', reset, { passive: true });
    });
  };

  const initFilm = () => {
    document.querySelectorAll('[data-culm-film]').forEach((film) => {
      const trigger = film.querySelector('[data-culm-film-play]');
      if (!trigger) return;
      trigger.addEventListener('click', () => {
        const nativeVideo = film.querySelector('video');
        if (nativeVideo) {
          film.classList.add('is-playing');
          nativeVideo.controls = true;
          nativeVideo.play().catch(() => {});
          trigger.closest('.culm-film__poster')?.remove();
          return;
        }
        const kind = trigger.dataset.culmVideoKind;
        const id = trigger.dataset.culmVideoId;
        if (!kind || !id) return;
        const iframe = document.createElement('iframe');
        iframe.title = 'CULM process film';
        iframe.loading = 'lazy';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        if (kind === 'youtube') iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`;
        if (kind === 'vimeo') iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1&dnt=1`;
        if (!iframe.src) return;
        film.querySelector('.culm-film__frame')?.appendChild(iframe);
        trigger.closest('.culm-film__poster')?.remove();
        film.classList.add('is-playing');
      });
    });
  };

  const localGuide = (message) => {
    const q = message.toLowerCase().trim();
    const context = pageContext();
    const recent = context.recentProducts || [];
    const collectionMatch = [
      ['white', 'White shirts', routes.white], ['black', 'Black shirts', routes.black], ['blue', 'Blue shirts', routes.blue],
      ['brown', 'Brown shirts', routes.brown], ['check', 'Checked shirts', routes.checked], ['plaid', 'Checked shirts', routes.checked],
      ['print', 'Printed shirts', routes.printed], ['solid', 'Solid shirts', routes.solid], ['stripe', 'Striped shirts', routes.striped]
    ].find(([key]) => q.includes(key));

    if ((q.includes('explain') || q.includes('this garment') || q.includes('this shirt')) && context.product) {
      const facts = [context.product, context.productType, context.fibre, context.price].filter(Boolean);
      return { text: `This page records ${facts.join(' / ')}. I will only use facts exposed by the garment page: fibre, provenance, construction, selected options and care records. Where a field is missing, CULM leaves it pending rather than inventing it.` };
    }
    if (q.includes('compare') || q.includes('recent')) {
      if (recent.length < 2) return { text: 'View at least two product pages and I can hold a small on-device recent-view record for comparison. I will compare only recorded facts such as title, category, displayed price and fibre—not invent fit or material details.' };
      return { text: `Recently viewed: ${recent.slice(0, 4).map((item) => [item.title, item.fibre, item.price].filter(Boolean).join(' / ')).join(' · ')}. For a precise decision, open each garment record to compare construction, measurements and provenance.` };
    }
    if (q.includes('build my') || q.includes('wardrobe') || q.includes('edit')) {
      return { text: 'A restrained shirt edit can start with three roles rather than more products: one quiet solid for repeat wear, one textural or checked piece for variation, and one directional shirt only if it adds a distinct use. Start with the full shirting register and narrow by actual cloth and fit records.', href: routes.men, cta: 'Build from the shirt register' };
    }
    if (q.includes('style') || q.includes('occasion') || q.includes('work') || q.includes('office') || q.includes('evening') || q.includes('travel')) {
      return { text: 'For work, begin with low-contrast solids or restrained stripes and let cloth texture carry the interest. For evening, use deeper tones or a sharper proportion. For travel, prioritise a fit that allows movement and follow the garment’s actual care record. I can route you to the solid edit without pretending a specific shirt suits you automatically.', href: routes.solid, cta: 'Open solid shirts' };
    }
    if (q.includes('quiet') || q.includes('minimal') || q.includes('less visual') || q.includes('low noise')) {
      return { text: 'For the quietest visual direction, start with solid shirting and judge the garment by cloth, proportion and construction rather than surface detail.', href: routes.solid, cta: 'Open the quiet edit' };
    }
    if (collectionMatch) return { text: `I can take you directly to the ${collectionMatch[1].toLowerCase()} edit. Use the product page to confirm cloth, measurements and construction before ordering.`, href: collectionMatch[2], cta: `Open ${collectionMatch[1]}` };
    if (q.includes('best') || q.includes('popular')) return { text: 'The best-sellers register is the quickest way to see the shirts customers are choosing most often.', href: routes.best, cta: 'Open best sellers' };
    if (q.includes('new') || q.includes('latest') || q.includes('arrival')) return { text: 'The new-arrivals register contains the latest shirts currently in the store.', href: routes.new, cta: 'Open new arrivals' };
    if (q.includes('women') || q.includes("women's") || q.includes('female')) return { text: 'Women’s shirting is marked as preparing in this draft until a real Women’s Shirts collection is created. CULM does not route you to unrelated products just to fill the link.' };
    if (q.includes('fit') || q.includes('size') || q.includes('measurement') || q.includes('loose') || q.includes('relaxed')) return { text: 'For fit, choose by the silhouette you want rather than an invented size prediction: relaxed for more volume, balanced for an everyday line, or closer for a neater line. Use the recorded garment measurements on the product page before ordering.' };
    if (q.includes('hemp') || q.includes('banana') || q.includes('bamboo') || q.includes('fibre') || q.includes('fiber') || q.includes('material')) return { text: 'CULM treats fibre as a record, not a halo claim. The garment should name its fibre breakdown and, where recorded, origin, processing route, mill and cloth weight. If a field is not documented, it remains pending rather than guessed.', href: '/#provenance', cta: 'See provenance' };
    if (q.includes('provenance') || q.includes('origin') || q.includes('field') || q.includes('mill') || q.includes('rett')) return { text: 'The provenance record follows Field → Retting → Mill → Cut. CULM’s rule is to name the place and date when known and leave unavailable information visibly pending.', href: '/#provenance', cta: 'Open provenance record' };
    if (q.includes('care plan') || q.includes('care') || q.includes('wash') || q.includes('repair') || q.includes('mend') || q.includes('alter') || q.includes('dye')) return { text: 'Start with the product-specific care record. Use the gentlest process that record permits, address damage early, and prefer mending or alteration before replacement. I do not infer wash temperature or chemistry when the garment page does not state it.', href: '/#service', cta: 'See lifetime service' };
    if (q.includes('environment') || q.includes('sustain') || q.includes('impact') || q.includes('eco') || q.includes('green')) return { text: 'CULM avoids a generic eco score. The environmental record shows only named processes, traceable origin and garment-life practices; unavailable measurements are marked as pending. Low-impact display also reduces decorative motion and keeps rich media user-initiated.', href: '/#environment-record', cta: 'Open environmental record' };
    if (q.includes('video') || q.includes('film') || q.includes('process')) return { text: 'Films are kept user-initiated so movement is available when useful without forcing video data on every visit.', href: '/#culm-film', cta: 'Open process film' };
    if (q.includes('3d') || q.includes('model') || q.includes('rotate')) return { text: 'CULM uses lightweight procedural 3D studies for atmosphere and supports real Shopify 3D product media. When a GLB/USDZ model is assigned to a product, the product viewer can show the actual interactive model rather than a fake rendering.', href: '/#culm-3d', cta: 'Open 3D cloth study' };
    if (q.includes('shirt') || q.includes('men') || q.includes('shop') || q.includes('find')) return { text: 'Start with the full Men’s Shirts register, or tell me a colour, pattern, fit direction, occasion, or whether you want new arrivals or best sellers and I’ll narrow the route.', href: routes.men, cta: 'Browse men’s shirts' };
    return { text: 'I can build a restrained shirt edit, compare recently viewed garments, suggest an occasion direction, explain the current garment record, think through fit, or read fibre, provenance, care and environmental information. I avoid inventing measurements or sustainability claims.' };
  };

  const remoteGuide = async (endpoint, message) => {
    if (!endpoint) return null;
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, context: pageContext(), brand: 'CULM', instruction: 'Use only supplied storefront facts for product-specific claims. Mark missing provenance, fit or environmental facts as unknown rather than guessing.' })
    });
    if (!response.ok) throw new Error(`AI proxy returned ${response.status}`);
    const data = await response.json();
    const text = data.answer || data.message || data.output || data.text;
    if (!text) throw new Error('AI proxy returned no answer');
    return { text: String(text), href: data.url ? String(data.url) : '', cta: data.cta ? String(data.cta) : '' };
  };

  const initIntelligence = () => {
    const panel = document.querySelector('[data-culm-ai]');
    const openers = [...document.querySelectorAll('[data-culm-ai-open]')];
    if (!panel || !openers.length) return;
    const endpoint = panel.dataset.endpoint?.trim() || '';
    const closers = [...panel.querySelectorAll('[data-culm-ai-close]')];
    const form = panel.querySelector('[data-culm-ai-form]');
    const input = panel.querySelector('[data-culm-ai-input]');
    const answer = panel.querySelector('[data-culm-ai-answer]');
    const quick = [...panel.querySelectorAll('[data-culm-ai-question]')];
    const actions = [...document.querySelectorAll('[data-culm-ai-action]')];
    let previousFocus = null;

    const focusable = () => [...panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((el) => el.offsetParent !== null);
    const open = (opener) => {
      previousFocus = opener || document.activeElement;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('culm-ai-open');
      window.requestAnimationFrame(() => input?.focus());
    };
    const close = () => {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('culm-ai-open');
      previousFocus?.focus?.();
    };
    const render = (result, prefix = '') => {
      if (!answer) return;
      answer.replaceChildren();
      const p = document.createElement('p');
      p.textContent = `${prefix}${result.text}`;
      answer.appendChild(p);
      if (result.href) {
        const a = document.createElement('a');
        a.href = result.href;
        a.textContent = result.cta || 'Open';
        answer.appendChild(a);
      }
    };
    const ask = async (message) => {
      if (!message?.trim()) return;
      if (input) input.value = message.trim();
      if (answer) answer.textContent = 'Reading the garment record…';
      if (endpoint) {
        try { render(await remoteGuide(endpoint, message.trim())); return; }
        catch (_) { render(localGuide(message), 'The connected AI service was unavailable, so local CULM guidance is answering instead. '); return; }
      }
      render(localGuide(message));
    };

    openers.forEach((button) => button.addEventListener('click', () => open(button)));
    closers.forEach((button) => button.addEventListener('click', close));
    quick.forEach((button) => button.addEventListener('click', () => ask(button.dataset.culmAiQuestion || button.textContent)));
    actions.forEach((button) => button.addEventListener('click', () => {
      const prompt = button.dataset.culmAiAction || button.textContent;
      open(button);
      window.setTimeout(() => ask(prompt), reducedMotion.matches ? 0 : 180);
    }));
    form?.addEventListener('submit', (event) => { event.preventDefault(); ask(input?.value || ''); });
    document.addEventListener('keydown', (event) => {
      if (!panel.classList.contains('is-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      const items = focusable();
      if (!items.length) return;
      if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); items[items.length - 1].focus(); }
      if (!event.shiftKey && document.activeElement === items[items.length - 1]) { event.preventDefault(); items[0].focus(); }
    });

    const context = pageContext();
    if (answer) {
      if (context.product) answer.textContent = `You’re viewing ${context.product}. Ask me to explain this garment, think through fit or styling, build a care plan, or compare recently viewed shirts.`;
      else if (context.collection) answer.textContent = `You’re viewing ${context.collection}. Ask me to build a small edit, find a quieter direction, choose for an occasion or compare recent shirts.`;
    }
  };

  const ready = () => {
    rememberCurrentProduct();
    initImpactControls();
    initImmersive();
    initFilm();
    initIntelligence();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
